/** Skeleton.tsx — fixed-height loading placeholder; `label` is announced via a status region. */

import type { HTMLAttributes } from 'react';

export interface SkeletonProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  label: string;
}

export const Skeleton = ({ label, className = 'h-16', ...rest }: SkeletonProps) => (
  // eslint-disable-next-line react/jsx-props-no-spreading -- primitive forwards native HTML attributes (data-testid, aria-*) to the root element
  <div {...rest} role="status" aria-busy="true">
    <span className="sr-only">{label}</span>
    <div aria-hidden="true" className={`animate-pulse rounded-lg bg-surface-2 ${className}`} />
  </div>
);
